import { Department } from "kinnect-models";
import { KAutocomplete, KForm, KPasswordCreateField, KTextField } from "kinnect-general";
import { FetchesData } from "kinnect-mixins";

export default KForm.extend( {
	name: "KRegisterForm",

	props: {
		cancelButtonText: {
			...KForm.options.props.cancelButtonText,
			default: "Back to Login"
		},

		formTitle: {
			...KForm.options.props.formTitle,
			default: "Request Access"
		},

		redirect: {
			...KForm.options.props.redirect,
			default: () => ( { name: "login" } )
		},

		submitButtonText: {
			...KForm.options.props.submitButtonText,
			default: "Request Access"
		},

		successMessage: {
			...KForm.options.props.successMessage,
			default: "Successfully submitted. We'll let you know after your account has been approved."
		},

		successTimeout: {
			...KForm.options.props.successTimeout,
			default: 10000
		}
	},

	mixins: [ FetchesData ],

	data: () => ( {
		formFields: {
			departments: [],
			email: null,
			firstName: null,
			lastName: null,
			password: null
		},
		fullName: "",
		departments: []
	} ),

	watch: {
		fullName: {
			handler( fullName ) {
				if ( fullName ) {
					const splitName = fullName.trim().split( " " );

					this.formFields.firstName = splitName[0];
					this.formFields.lastName = splitName[1];
				} else {
					this.formFields.firstName = null;
					this.formFields.lastName = null;
				}
			},
			immediate: true
		}
	},

	methods: {
		async fetchDepartments() {
			this.departments = await Department.orderBy( "name" ).get();
		},

		async fetch() {
			await this.fetchDepartments();
		}
	},

	render() {
		return <KForm
			attrs={{
				...this.$props,
				action: "users/requests",
				data: this.formFields,
				method: "post"
			}}
		>
			<KTextField
				label="First and Last Name*"
				prependIcon="person"
				required
				vModel={this.fullName}
				validationName="name"
				validationRules="required|alpha_spaces|numberOfWords:2|nameAvailable"
			></KTextField>

			<KAutocomplete
				chips
				deletableChips
				itemText="name"
				itemValue="id"
				items={this.departments}
				label="Department(s)*"
				loading={this.$wait.is( "get departments" )}
				multiple
				prependIcon="location_city"
				required
				vModel={this.formFields.departments}
				validationName="department(s)"
				validationRules="required"
			></KAutocomplete>

			<KTextField
				label="Email*"
				prependIcon="email"
				required
				type="email"
				vModel={this.formFields.email}
				validationName="email"
				validationRules="required|email|emailAvailable"
			></KTextField>

			<KPasswordCreateField
				label="Password*"
				prependIcon="lock"
				required
				vModel={this.formFields.password}
				validationName="password"
				validationRules="required"
			></KPasswordCreateField>
		</KForm>;
	}
} );
